import React, { memo, TouchEventHandler, useRef, useState } from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Icon, Image, VideoIcon } from '@/components';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';

// import required modules
import { Keyboard, FreeMode, Pagination, Thumbs } from 'swiper';
import { ImageModel } from '@/models';
import { TFunction } from 'next-i18next';
import ImageZoom from './ImageZoom';

export type GalleryPartialProps = {
  images: ImageModel[];
  isMobile: boolean;
  handleModal: () => void;
  linkVideo: string | null;
  t: TFunction;
};
type IPosition = {
  x: string;
  y: string;
};
const GalleryPartial = ({ images, isMobile, handleModal, linkVideo, t }: GalleryPartialProps) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);
  const [positions, setPositions] = useState<IPosition>({
    x: 'center',
    y: 'center',
  });

  const items = (Array.isArray(images) ? images : []).map(({ url }) => ({
    original: url,
    thumbnail: url,
    originalAlt: 'Product image',
    thumbnailAlt: 'product thumbnail image',
  }));

  function handleMouseMove(evt: any) {
    var e = evt || window.event;
    let rect = (document.getElementById('swiper') as any).getBoundingClientRect();
    if (!rect) return;
    let x = ((e.clientX - (rect.x || 0)) / (rect.width - 2)) * 100 || 50; // Wonderfully
    let y = ((e.clientY - (rect.y || 0)) / (rect.height - 2)) * 100 || 50; // Simple!
    // if (rect.top) {
    //   x = x - rect.left;
    //   y = y - rect.top;
    // }
    setPositions({ x: x.toFixed(4), y: y.toFixed(4) });
  }

  return (
    <>
      <div>
        <Swiper
          slidesPerView={1}
          spaceBetween={30}
          keyboard={{
            enabled: true,
          }}
          pagination={{
            clickable: true,
          }}
          thumbs={{ swiper: thumbsSwiper }}
          modules={isMobile ? [FreeMode, Keyboard, Pagination] : [FreeMode, Keyboard, Thumbs]}
          className="product-images"
          id="swiper"
        >
          {items.map((item, key) => (
            <SwiperSlide
              key={`item-${key}`}
              className="tw-bg-gray-50 md:tw-rounded-5 md:tw-border tw-border-gray-70 tw-border-opacity-50 tw-overflow-hidden tw-relative"
            >
              <div className="tw-w-full p-100p tw-relative" onMouseMove={handleMouseMove}>
                {/* <ImageZoom image={item.original} /> */}
                <div
                  className="!tw-absolute tw-bg-center tw-bg-cover tw-bg-no-repeat tw-top-0 tw-left-0 tw-w-full tw-h-full tw-z-1 hover:tw-transform tw-transition tw-ease-in-out tw-duration-300 hover:tw-scale-[2.25]"
                  style={{
                    backgroundImage: `url('${item.original}')`,
                    transformOrigin: `${positions?.x}% ${positions?.y}%`,
                  }}
                ></div>
              </div>
            </SwiperSlide>
          ))}
          {linkVideo &&
            (!isMobile ? (
              <div
                className="tw-absolute tw-bottom-4 tw-left-1/2 tw--translate-x-1/2 tw-z-10 tw-py-2 tw-px-4 tw-flex tw-items-center tw-gap-x-2 tw-cursor-pointer tw-bg-primary-main tw-text-white tw-rounded-5"
                onClick={handleModal}
              >
                <Icon icon={<VideoIcon />} /> <span>{t('detail.label.watch-video')}</span>
              </div>
            ) : (
              <div className="tw-absolute tw-block md:tw-hidden tw-top-6 tw-right-4 tw-z-10">
                <div
                  className="tw-flex tw-items-center tw-justify-center tw-flex-col tw-w-10 tw-h-10  tw-cursor-pointer tw-bg-white tw-text-primary-main tw-rounded-full"
                  onClick={() => handleModal()}
                >
                  <Icon icon={<VideoIcon />} />
                </div>
              </div>
            ))}
        </Swiper>
        {!isMobile && (
          <Swiper
            spaceBetween={20}
            slidesPerView={4}
            freeMode={true}
            watchSlidesProgress={true}
            onSwiper={setThumbsSwiper}
            modules={[FreeMode, Thumbs]}
            className="product-images-thumb tw-mt-5 "
          >
            <div>
              {items.map((item, key) => (
                <SwiperSlide
                  key={`item-${key}`}
                  className="tw-bg-gray-50 tw-rounded-5 tw-border tw-border-gray-70 tw-overflow-hidden"
                >
                  <div className="tw-w-full p-100p tw-relative tw-bg-gray-50 tw-rounded-5 ">
                    <Image
                      src={item.original}
                      className="!tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full"
                      alt={item.originalAlt}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </div>
          </Swiper>
        )}
      </div>
    </>
  );
};

export default memo(GalleryPartial);
